import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { ModalControl } from './modal.types';

@Component({
  selector: 'cohrex-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ModalComponent {
  // @HostListener('click', ['$event.target'])
  // clicked(args: any) {
  //   if (args.getAttribute('id') === 'modal') {
  //     const element = args.parentElement.parentElement as HTMLDivElement;
  //     element.classList.remove('visible');
  //     element.classList.add('hidden');
  //   }
  // }
  // @HostListener('document:click', ['$event.target'])
  // documentClicked(args: any) {
  //   console.log(args, args.getAttribute('data-modal'));
  // }

  private _title?: string;
  @Input()
  set title(value: string | undefined) {
    this._title = value;
  }
  get title(): string | undefined {
    return this._title;
  }

  private _content?: string | TemplateRef<any>;
  @Input()
  set content(value: string | TemplateRef<any> | undefined) {
    this._content = value;
  }
  get content(): string | TemplateRef<any> | undefined {
    return this._content;
  }

  private _showModal?: boolean;
  @Input()
  set showModal(value: boolean | undefined) {
    this._showModal = value;
  }
  get showModal(): boolean | undefined {
    return this._showModal;
  }

  private _disabled?: boolean;
  @Input()
  set disabled(value: boolean | undefined) {
    this._disabled = value;
  }
  get disabled(): boolean | undefined {
    return this._disabled;
  }

  private _loading?: boolean;
  @Input()
  set loading(value: boolean | undefined) {
    this._loading = value;
  }
  get loading(): boolean | undefined {
    return this._loading;
  }

  private _hasCancelControl?: boolean;
  @Input()
  set hasCancelControl(value: boolean | undefined) {
    this._hasCancelControl = value;
  }
  get hasCancelControl(): boolean | undefined {
    return this._hasCancelControl;
  }

  private _hasContinueControl?: boolean = true;
  @Input()
  set hasContinueControl(value: boolean | undefined) {
    this._hasContinueControl = value;
  }
  get hasContinueControl(): boolean | undefined {
    return this._hasContinueControl;
  }

  private _errorMessage?: string = '';
  @Input()
  set errorMessage(value: string | undefined) {
    this._errorMessage = value;
  }
  get errorMessage(): string | undefined {
    return this._errorMessage;
  }

  private _control?: ModalControl;
  @Input()
  set control(value: ModalControl | undefined) {
    this._control = value;
  }
  get control(): ModalControl | undefined {
    return this._control;
  }

  @Input() small?: boolean = false;
  @Input() closeText?: string = '';
  @Input() cancelText?: string = 'app.cancel';
  @Input() size?: string = '';
  @Output()
  closeModal: EventEmitter<void> = new EventEmitter();
  @Output()
  continue: EventEmitter<any> = new EventEmitter();
}
